// iter158 — BFR Email module: templates, composer, history.
// Uses the CRM Gmail Integration via backend proxy — the browser never sees
// the CRM secret. All routes require BFR admin JWT.

import { toast } from 'sonner';

export const EMAIL_TEMPLATES = {
  ota_rejection: {
    label: 'OTA Booking Rejection',
    subject: 'Booking Rejection – {{property_name}} – {{booking_id}}',
    body: `Dear {{ota_name}} Team,

We regret to inform you that the booking mentioned below cannot be accepted by the property.

Property: {{property_name}}
Booking ID: {{booking_id}}
Guest Name: {{guest_name}}
Check-in: {{check_in_date}}
Check-out: {{check_out_date}}
Rooms: {{number_of_rooms}}
Guests: {{number_of_guests}}

Reason:
{{rejection_reason}}

Please take the necessary action regarding this booking.

Regards,
{{property_name}}
Superhost`,
  },
  ota_payment_not_received: {
    label: 'OTA Payment Not Received',
    subject: 'Payment Not Received – {{property_name}} – {{booking_id}}',
    body: `Dear {{ota_name}} Team,

We have not received the payment for the following booking.

Property: {{property_name}}
Booking ID: {{booking_id}}
Guest Name: {{guest_name}}
Check-in: {{check_in_date}}
Check-out: {{check_out_date}}
Rooms: {{number_of_rooms}}
Guests: {{number_of_guests}}
Booking Amount: {{booking_amount}}

Please check the payment status and arrange the payment at the earliest.

Regards,
{{property_name}}
Superhost`,
  },
  custom: {
    label: 'Custom Email',
    subject: '',
    body: '',
  },
};

export const REJECTION_REASONS = [
  'No rooms available',
  'Property unable to accommodate',
  'Booking dates unavailable',
  'Payment issue',
  'Guest-related issue',
  'Property owner rejected',
  'Other',
];

export const AVAILABLE_VARIABLES = [
  'property_name', 'booking_id', 'guest_name', 'guest_phone', 'guest_email',
  'ota_name', 'check_in_date', 'check_out_date', 'booking_date',
  'number_of_guests', 'number_of_rooms', 'booking_amount',
  'payment_status', 'booking_status', 'rejection_reason', 'property_owner_name',
];

// Client-side fallback renderer — used when the server-side /resolve endpoint
// is unavailable (offline preview). Matches backend semantics: unknown or
// missing variables render as an empty string (never "undefined" or "null").
export const renderTemplate = (text, variables = {}) => {
  if (!text) return '';
  return text.replace(/\{\{\s*([a-zA-Z_][a-zA-Z0-9_]*)\s*\}\}/g, (_m, key) => {
    const v = variables[key];
    return v === undefined || v === null ? '' : String(v);
  });
};

// Standard toast wrapper for failed API calls.
export const notifyEmailError = (err, fallback = 'Something went wrong') => {
  const msg = err?.response?.data?.detail || err?.message || fallback;
  toast.error(msg);
};
